import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { telegramService } from '../services/telegram';
import { historyService } from '../services/history';
import {
  canTelegramHistoryBack,
  notifyTelegramBackStackChanged,
  setTelegramHistoryBackHandler,
} from '../services/telegramBackStack';

/**
 * Глобальная кнопка «Назад» Telegram: сначала закрывает верхний оверлей (стек),
 * иначе — внутренняя история чтения (historyService: стих → глава → …).
 */
export default function TelegramBackButtonBridge() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!telegramService.isTelegramWebApp) return undefined;

    setTelegramHistoryBackHandler(() => {
      const url = historyService.goBack();
      if (url) {
        navigate(url, { replace: true });
      }
    });

    const onPopState = () => {
      historyService.syncPositionToPath(
        `${window.location.pathname}${window.location.search}`
      );
      notifyTelegramBackStackChanged();
    };
    window.addEventListener('popstate', onPopState);

    notifyTelegramBackStackChanged();

    return () => {
      setTelegramHistoryBackHandler(null);
      window.removeEventListener('popstate', onPopState);
      notifyTelegramBackStackChanged();
    };
  }, [navigate]);

  useEffect(() => {
    if (!telegramService.isTelegramWebApp) return;
    notifyTelegramBackStackChanged();
  }, [location.pathname, location.search]);

  return null;
}

export { canTelegramHistoryBack };
